type Env = Record<string, string | undefined>;

export interface AppConfig {
  apiBase: string;
  firebase: {
    apiKey: string;
    projectId: string;
    authDomain: string;
    authEmulatorUrl: string | undefined;
  };
}

// Tenancy is NO LONGER build-time configuration (staff-auth Task 5). VITE_BUSINESS_ID and
// VITE_SITE_ID are gone: business and site are resolved per session from GET /auth/staff/me,
// so one deployment serves every business. Nothing here is required any more — every value
// has a working default — so loadConfig cannot throw and there is no ConfigError screen.
export function loadConfig(env: Env, isDev = false): AppConfig {
  const projectId = env.VITE_FIREBASE_PROJECT_ID ?? "carwash-dev";
  return {
    apiBase: env.VITE_API_BASE_URL ?? "http://localhost:5263",
    firebase: {
      apiKey: env.VITE_FIREBASE_API_KEY ?? "fake-api-key",
      projectId,
      // Google popup will not start without this. The project default is the usual
      // Firebase hosting domain; set VITE_FIREBASE_AUTH_DOMAIN only to override it.
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN ?? `${projectId}.firebaseapp.com`,
      // Explicit URL wins; otherwise dev builds default to the compose emulator.
      // Same shape as customer-web's config.
      authEmulatorUrl: env.VITE_FIREBASE_AUTH_EMULATOR_URL ?? (isDev ? "http://localhost:9099" : undefined),
    },
  };
}

export const config: AppConfig = loadConfig(
  import.meta.env as unknown as Env,
  import.meta.env.DEV,
);
